import * as React from 'react'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'

interface Props {
	isTopPage: boolean
}

export default class HeaderMenuComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		return (
			<div className="header top">
				<div className="row">
					<div className="container-fluid">
						<div className="head col-xs-12 col-sm-12 clearfix">
							<div className="logo float-left">
								<Link to="/">
									<img src="img/ic_header_logo.png" alt="GENESIS" />
								</Link>
							</div>
							<div className="menu float-right rmspace">
								<ul>
									<li>
										{
											this.props.isTopPage ?
											<ScrollLink
												className="menu-service"
												to="service"
												smooth={true}
												duration={640}
											>
												SERVICE
											</ScrollLink>
											: <a className="menu-service" href="/#service">SERVICE</a>
										}
									</li>
									<li>
										{
											this.props.isTopPage ?
											<ScrollLink
												className="menu-works"
												to="works"
												smooth={true}
												duration={640}
											>
												WORKS
											</ScrollLink>
											: <a className="menu-works" href="/#works">WORKS</a>
										}
									</li>
									<li>
										{
											this.props.isTopPage ?
											<ScrollLink
												className="menu-clients"
												to="clients"
												smooth={true}
												duration={640}
											>
												OUR CLIENTS
											</ScrollLink>
											: <a className="menu-clients" href="/#clients">OUT CLIENTS</a>
										}
									</li>
									<li>
										{
											this.props.isTopPage ?
											<ScrollLink
												className="menu-company"
												to="company"
												smooth={true}
												duration={640}
											>
												COMPANY
											</ScrollLink>
											: <a className="menu-company" href="/#company">COMPANY</a>
										}
									</li>
									<li>
										<ScrollLink
											className="menu-contact"
											to="contacts-before"
											smooth={true}
											duration={640}
											id="contact"
										>
											CONTACT
										</ScrollLink>
									</li>
								</ul>
							</div>
						</div>
						<div className="head col-xs-12 col-sm-12 clearfix">
							<div className="logo" />
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/headerMenuComponent.tsx